import { useMutation, useQuery } from 'react-query'
import {
  useSaveSpaCredentialQuery,
  saveM2MCredentialQuery,
  getLdsTokenQuery,
  getListAccessTokenQuery,
  getListOAuthClientsQuery,
  removeCredentialQuery,
  getOAuthClientQuery
} from '../api/developersQueries'
import { OAuthClient, OAuthClientType, TokensResponse } from '../types'
import { AccessTokenResponse } from 'features/access-token/types'

function useLdsToken(props?: { enabled?: boolean }) {
  const enabled = props?.enabled ?? true
  const { data } = useQuery<TokensResponse, Error>({ ...getLdsTokenQuery, enabled })

  const token = data?.token

  return { data: token }
}

function useOAuthClient<T>({ id }: { id: string }) {
  return useQuery<T, Error>(getOAuthClientQuery(id))
}

function useOAuthClients({ type }: { type: OAuthClientType }) {
  return useQuery<OAuthClient[], Error>(getListOAuthClientsQuery(type))
}

function useRemoveCredential({ type }) {
  return useMutation(removeCredentialQuery(type))
}

function useSaveSpaCredential(id?: string) {
  return useMutation(useSaveSpaCredentialQuery(id))
}

function useSaveM2MCredential(id?: string) {
  return useMutation(saveM2MCredentialQuery(id))
}

function useAccessTokens() {
  const { data, ...queryResponse } = useQuery<AccessTokenResponse, Error>(getListAccessTokenQuery())

  return { data, ...queryResponse }
}

export {
  useLdsToken,
  useOAuthClient,
  useOAuthClients,
  useAccessTokens,
  useRemoveCredential,
  useSaveSpaCredential,
  useSaveM2MCredential
}
